import { defineMessage } from '../../services/localization';

export const messages = {
    youCanAlsoClose: defineMessage('you_can_also_close_this_popup_and_open_it_again'),
    close: defineMessage('close'),
};
